import { CountryCode } from '@gql/graphql';
import { useRouter } from './useRouter';

/*
 *   Articles are only available in French and Dutch.
 *   For this reason, we disable them for germans + german-speaking swiss users
 */
export const useShowArticles = () => {
  const { countryCode, language } = useRouter();

  const isFrenchSpeakingSwissUser = language === 'fr' && countryCode === CountryCode.CH;
  const isSupportedCountry = [CountryCode.BE, CountryCode.NL, CountryCode.FR].includes(countryCode);

  const shouldShowArticles = isSupportedCountry || isFrenchSpeakingSwissUser;
  return { shouldShowArticles };
};
